export default {
  'app.setting.pagestyle': 'Cài đặt kiểu trang',
  'app.setting.pagestyle.dark': 'Giao diện tối',
  'app.setting.pagestyle.light': 'Giao diện sáng',
  'app.setting.content-width': 'Chiều rộng nội dung',
  'app.setting.content-width.fixed': 'Cố định',
  'app.setting.content-width.fluid': 'Linh hoạt',
  'app.setting.themecolor': 'Màu chủ đề',
  'app.setting.themecolor.dust': 'Đỏ bụi',
  'app.setting.themecolor.volcano': 'Cam núi lửa',
  'app.setting.themecolor.sunset': 'Cam hoàng hôn',
  'app.setting.themecolor.cyan': 'Xanh lơ',
  'app.setting.themecolor.green': 'Xanh cực',
  'app.setting.themecolor.daybreak': 'Xanh bình minh (mặc định)',
  'app.setting.themecolor.geekblue': 'Xanh công nghệ',
  'app.setting.themecolor.purple': 'Tím vàng',
  'app.setting.navigationmode': 'Chế độ điều hướng',
  'app.setting.sidemenu': 'Bố cục menu bên',
  'app.setting.topmenu': 'Bố cục menu trên',
  'app.setting.fixedheader': 'Cố định tiêu đề',
  'app.setting.fixedsidebar': 'Cố định thanh bên',
  'app.setting.fixedsidebar.hint': 'Áp dụng cho bố cục menu bên',
  'app.setting.hideheader': 'Ẩn tiêu đề khi cuộn',
  'app.setting.hideheader.hint': 'Áp dụng khi bật ẩn tiêu đề',
  'app.setting.othersettings': 'Cài đặt khác',
  'app.setting.weakmode': 'Chế độ hỗ trợ người mù màu',
  'app.setting.copy': 'Sao chép cài đặt',
  'app.setting.copyinfo':
    'Sao chép thành công, vui lòng thay thế defaultSettings trong src/models/setting.js',
  'app.setting.production.hint':
    'Bảng cài đặt chỉ hiển thị ở môi trường phát triển, vui lòng chỉnh sửa thủ công',
};
